import FIGURES_RAW from "@/game/figures.json";

export const N = 12;
export const COLORS = { rosa: "#F2AEC4", oro: "#C6AE4E" };

export const SHAPES = {
  tira2: { cells: [[0, 0], [1, 0]] },
  tira3: { cells: [[0, 0], [1, 0], [2, 0]] },
  tira4: { cells: [[0, 0], [1, 0], [2, 0], [3, 0]] },
  tira5: { cells: [[0, 0], [1, 0], [2, 0], [3, 0], [4, 0]] },
  tira6: { cells: [[0, 0], [1, 0], [2, 0], [3, 0], [4, 0], [5, 0]] },
  diagonal2: { cells: [[0, 0], [1, 1]], diag: true },
  diagonal3: { cells: [[0, 0], [1, 1], [2, 2]], diag: true },
  esquina: { cells: [[0, 0], [0, 1], [1, 1]] },
  te: { cells: [[0, 0], [1, 0], [2, 0], [1, 1]] },
  cruz: { cells: [[1, 0], [0, 1], [1, 1], [2, 1], [1, 2]] },
  triangulo: { cells: [[0, 0], [1, 0], [2, 0], [0, 1], [1, 1], [0, 2]] },
  marco: { cells: [[0, 0], [1, 0], [2, 0], [0, 1], [2, 1], [0, 2], [1, 2], [2, 2]] },
  placa: { cells: [[0, 0], [1, 0], [2, 0], [0, 1], [1, 1], [2, 1]] },
  rueda: { cells: [[1, 0], [0, 1], [1, 1], [2, 1], [1, 2]], disc: true },
};
export const SHAPE_KEYS = Object.keys(SHAPES);
export const SHAPE_LABELS = {
  tira2: "tira de 2", tira3: "tira de 3", tira4: "tira de 4", tira5: "tira de 5", tira6: "tira de 6",
  diagonal2: "diagonal de 2", diagonal3: "diagonal de 3", esquina: "esquina L", te: "pieza T", cruz: "cruz",
  triangulo: "triángulo", marco: "marco", placa: "placa 2×3", rueda: "rueda",
};
export const shapeSize = (shape, rot) => {
  const c = shapeCells(shape, rot);
  return [Math.max(...c.map((p) => p[0])) + 1, Math.max(...c.map((p) => p[1])) + 1];
};

const normalize = (cells) => {
  const mx = Math.min(...cells.map((c) => c[0])), my = Math.min(...cells.map((c) => c[1]));
  return cells.map(([x, y]) => [x - mx, y - my]);
};

export const shapeCells = (shape, rot) => {
  let cells = SHAPES[shape].cells;
  for (let i = 0; i < (rot % 4); i++) cells = normalize(cells.map(([x, y]) => [-y, x]));
  return cells;
};

export const pieceCells = (p) => (p.cells ? p.cells : shapeCells(p.shape, p.rot).map(([x, y]) => [p.x + x, p.y + y]));

export const occupancy = (pieces) => {
  const m = new Map();
  pieces.forEach((p) => pieceCells(p).forEach(([x, y]) => m.set(`${x},${y}`, (m.get(`${x},${y}`) || 0) + 1)));
  return m;
};

export const canPlace = (pieces, piece) => {
  const occ = occupancy(pieces);
  return pieceCells(piece).every(([x, y]) => x >= 0 && y >= 0 && x < N && y < N && (occ.get(`${x},${y}`) || 0) < 2);
};

export const footprint = (pieces) => {
  const cells = [...new Set(pieces.flatMap((p) => pieceCells(p).map(([x, y]) => `${x},${y}`)))].map((s) => s.split(",").map(Number));
  if (!cells.length) return "";
  return normalize(cells).map(([x, y]) => `${x},${y}`).sort().join("|");
};

export const matches = (pieces, figure) => footprint(pieces) !== "" && footprint(pieces) === footprint(figure.pieces);

const centerFigure = (f) => {
  const all = f.pieces.flatMap((p) => p.cells);
  const mx = Math.min(...all.map((c) => c[0])), my = Math.min(...all.map((c) => c[1]));
  const w = Math.max(...all.map((c) => c[0])) - mx + 1, h = Math.max(...all.map((c) => c[1])) - my + 1;
  const ox = Math.floor((N - w) / 2) - mx, oy = Math.floor((N - h) / 2) - my;
  return { ...f, pieces: f.pieces.map((p, i) => ({ ...p, id: `f${i}`, cells: p.cells.map(([x, y]) => [x + ox, y + oy]) })) };
};
export const FIGURES = FIGURES_RAW.map(centerFigure);
export const SERIES = [...new Set(FIGURES.map((f) => f.serie))];
